import axios, { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";
import { API_URL } from "../consts";
import { CardsData } from "../prenotazione/CardsData";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { RigaSocio } from "../prenotazione/RigaSocio";
import { Loading } from "../ui/Loading";
import { Transazioni_Causali } from "../prismaTypes";
import { useSnackbar } from "notistack";
//import { useEffect } from "react";
import { uiStore } from "../uiStore";
import { queryClient } from "../App";
import Alert from "@mui/material/Alert";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { format } from "date-fns";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { Cards } from "../prismaTypes";
import { readDate } from "../utils/dateUtils";
import { EuroFormatter } from "../utils/EuroFormatter";
//import React from "react";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import MuiInput from '@mui/material/Input';
//import VolumeUp from '@mui/icons-material/VolumeUp';
import EuroIcon from '@mui/icons-material/Euro';
import { Input } from "@mui/material";
/*
type Inputs = {
  idConto: number;
  importo: number;
  idCausale: number;
  note: string;
};
const schema = yup
  .object({
    idConto: yup.number().typeError("Seleziona un conto!").required(),
    importo: yup.number().typeError("Importo deve essere un numero!").min(0).required(),
    idCausale: yup.number().typeError("Seleziona una causale!").required(),
    note: yup.string(),
  })
  .required();
*/



export function Ricarica() {
  const role = oraPrenotaStore((state) => state.role);
  const { isLoading, data } = useQuery<
    {
      cards: (Cards & {
        nome: string;
        cognome: string;
        importoResiduo: number;
        dataScadenzaCertificato: string;
        dataScadenza: string;
      })[];
    },
    AxiosError
  >(["ricarica/findMyCard"], () => axios.get(API_URL + "ricarica/findMyCard").then((res) => res.data), {
    enabled: role === "USER",
  });

  const [value, setValue] = React.useState(30);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value === '' ? 0 : Number(event.target.value));
  };

  //let satispayPaymentId = "";

  const avviaRicaricaSatispay = () => {
    //dato che la funzione è invocata dal click sul pulsante, nel momento in cui è cliccato loggo in console l'id del bottone stesso
    console.log("avviaRicaricaSatispay");
    console.log(value);
    let datiRicarica = null;
    
    //axios.get(API_URL + "ricarica/info").then(
    axios.post(API_URL + "ricarica/satispaystart", { importo: value }).then(
      (res) => {
        datiRicarica = res.data;
        //console.log("datiRicarica",datiRicarica);
        //quando ricevo l'output della chiamata axios, salvo i dati nell'archiviazione locale per poi redirezionare l'utente a /app/ricarica/satispay
        //salvo in localStorage una variabile con nome SatispayPaymentDetails che contiene i dati ricevuti dalla chiamata axios
        localStorage.setItem("satispayPaymentDetails", JSON.stringify(datiRicarica));
        console.log("Leggo dallo storage i datiRicarica:",localStorage.getItem("satispayPaymentDetails"));
        //redirigo l'utente alla pagina di conferma della ricarica
        window.location.href = "/app/ricarica/satispay";
      }
    );
    //console.log("datiRicarica",res.data);
    //axios.post(API_URL + "ricarica/avviaRicaricaSatispay", { importo: value }).then((res) => res.data, {} );
  };

  const handleBlur = () => {
    if (value < 0) {
      setValue(0);
    } else if (value > 100) {
      setValue(100);
    }
  };

  if (isLoading || !data) return <></>;

  const userData = data.cards[0];

  const dataScadenzaCertificato =
    userData.dataScadenzaCertificato === null ? null : readDate(userData.dataScadenzaCertificato);
  const dtScadenza = userData.dataScadenza === null ? null : readDate(userData.dataScadenza);

  /*const [selectedRange, setSelectedRange] = useState(0);

  const handleRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRange(Number(event.target.value));
  };*/

  

  return (
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell>Socio</TableCell>
          <TableCell>
            {userData.nome} {userData.cognome}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Card</TableCell>
          <TableCell>{userData.codice}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Scadenza</TableCell>
          <TableCell>
            {dtScadenza !== null && (
              <span className="UserInfo__cell">
                <span>{format(dtScadenza, "dd/MM/yyyy")}</span>
                {dtScadenza < new Date() && <WarningAmberIcon fontSize={"small"} color={"error"} />}
              </span>
            )}
          </TableCell>
        </TableRow>
        {userData.dataScadenzaCertificato !== null && (
          <TableRow>
            <TableCell>Scad. certificato</TableCell>
            <TableCell>
              {dataScadenzaCertificato !== null && (
                <span className="UserInfo__cell">
                  <span>{format(dataScadenzaCertificato, "dd/MM/yyyy")}</span>
                  {dataScadenzaCertificato < new Date() && (
                    <WarningAmberIcon fontSize={"small"} color={"error"} />
                  )}
                </span>
              )}
            </TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell>Saldo</TableCell>
          <TableCell>
            <span className="UserInfo__cell">
              <span>{EuroFormatter.format(userData.importoResiduo)}</span>
              {userData.importoResiduo < 0 && (
                <WarningAmberIcon fontSize={"small"} color={"error"} />
              )}
            </span>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Ricarica</TableCell>
          <TableCell>
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid item>
                <EuroIcon />
              </Grid>
              <Grid item xs>
                <Slider
                  value={typeof value === 'number' ? value : 10}
                  onChange={handleSliderChange}
                  aria-labelledby="input-slider"
                  step={10}
                  min={10}
                />
              </Grid>
              <Grid item>
                <Input
                  value={value}
                  size="small"
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  inputProps={{
                    step: 10,
                    min: 10,
                    max: 100,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}
                />
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Button variant="contained" color="primary" onClick={avviaRicaricaSatispay}>
              Ricarica con Satispay
            </Button>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
